export default function Logo() {
  return (
    <div className="logo" aria-hidden>
      <img src="./images/logo/logo.png" alt="Michel Rico" />
    </div>
  );
}
